module.exports = __webpack_public_path__ + "img/icon-dashboard.445d684a.svg";